import { FunctionComponent } from 'react'

import Text from '../Text'
import { IAutocomplete } from './AutocompleteComponent.types'
import {
  StyledAutocomplete,
  StyledTextField,
  LabelContainer,
  HelperMessage,
} from './styles'

const Autocomplete: FunctionComponent<IAutocomplete> = ({
  label,
  placeholder,
  value,
  helperMessage,
  onChange,
  inputValue,
  onInputChange,
  options,
  getOptionDisabled,
  getOptionLabel,
  getOptionSelected,
  loading,
  popupIcon: PopupIcon,
  className,
  defaultValue,
  open,
  noOptionsText,
}) => {
  return (
    <>
      <LabelContainer>
        {label && <Text>{label}</Text>}
        {helperMessage && <HelperMessage>{helperMessage}</HelperMessage>}
      </LabelContainer>
      <StyledAutocomplete
        id={label?.toLocaleString() || placeholder}
        defaultValue={defaultValue}
        className={className}
        value={value}
        onChange={onChange}
        inputValue={inputValue}
        onInputChange={onInputChange}
        options={options}
        getOptionLabel={getOptionLabel}
        getOptionSelected={getOptionSelected}
        getOptionDisabled={getOptionDisabled}
        noOptionsText={
          noOptionsText || `Nenhum resultado encontrado ${inputValue}`
        }
        open={open}
        renderInput={params => (
          <StyledTextField
            {...params}
            placeholder={placeholder}
            variant="outlined"
          />
        )}
        loading={loading}
        popupIcon={PopupIcon && <PopupIcon fontSize="small" />}
      />
    </>
  )
}

export default Autocomplete
